import Aos from 'aos';
import 'aos/dist/aos.css';
import { useRef, useState } from 'react';
import { Grid, Container, Title, createStyles, Image } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { useEffect } from 'react';
const useStyle = createStyles((theme) => ({
  container1: {
    '@media (min-width: 1200px) and (min-height: 700px)': {
      marginBottom: '0!important',
    },
  },
  container: {
    width: 'auto',
    height: 150,
    textAlign: 'center',
    padding: 0,
  },
  container2: {
    width: 'auto',
    height: 120,
    textAlign: 'center',
    padding: 0,
  },
  container3: {
    width: 'auto',
    height: 110,
    textAlign: 'center',
    padding: 0,
  },
  image: {
    width: 'auto',
    height: '100%',
  },
  carouselPartners1: {
    '@media (min-width: 1200px) and (min-height: 700px)': {
      marginBottom: 0,
    },
  },
  carouselPartners2: {
    '@media (max-height: 500px)': {
      display: 'none!important',
    },
    '@media (min-height: 500px)': {
      display: 'block!important',
    },
    '@media (max-height: 670px)': {
      display: 'none!important',
    },
    '@media (min-height: 800px)': {
      display: 'block!important',
    },
  },
  carouselPartners3: {
    '@media (max-width: 600px)': {
      display: 'none!important',
    },
    '@media (max-height: 500px)': {
      display: 'none!important',
    },
    '@media (min-height: 500px)': {
      display: 'none!important',
    },
    '@media (min-height: 800px)': {
      display: 'block!important',
    },
    '@media (min-height: 900px)': {
      display: 'block!important',
      marginBottom: '13%',
    },
  },
}));

const PartnersCompo = (props) => {
  const autoplay = useRef(Autoplay({ delay: 2000 }));
  const { classes } = useStyle();
  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });
  }, []);
  return (
    <div className={`container mb-4 ${classes.container1}`}>
      <div className="row">
        <Carousel
          className={classes.carouselPartners1}
          withControls={true}
          controlSize={40}
          height={150}
          dragFree
          //slideSize="33.333333%"
          slideSize="20%"
          slideGap={20}
          mb={20}
          loop
          align="start"
          slidesToScroll={3}
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}
          styles={{
            control: {
              backgroundColor: '#F2EEC8',
              color: '#F56600',
              borderColor: '#F2EEC8',
              '&[data-inactive]': {
                opacity: 0,
                cursor: 'default',
              },
            },
          }}
        >
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait1.jpg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait3.jpg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait2.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait4.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait5.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait6.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/potraitlogo/potrait7.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
        </Carousel>
      </div>

      {/*-------------------------------------------- 
        CAROUSEL 2
      ---------------------------------------------*/}
      <div className="row">
        <Carousel
          className={classes.carouselPartners2}
          withControls={true}
          controlSize={40}
          height={200}
          // slideSize="33.333333%"
          slideSize="20%"
          slideGap={20}
          loop
          dragFree
          mt={50}
          align="start"
          slidesToScroll={3}
          plugins={[autoplay.current]}
          onMouseEnter={autoplay.current.stop}
          onMouseLeave={autoplay.current.reset}
          styles={{
            control: {
              backgroundColor: '#F2EEC8',
              color: '#F56600',
              borderColor: '#F2EEC8',
              '&[data-inactive]': {
                opacity: 0,
                cursor: 'default',
              },
            },
          }}
        >
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape1.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape2.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape3.png')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape4.png')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape5.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape6.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
          <div className="col">
            <Carousel.Slide>
              <Container className={classes.container}>
                <img
                  src={require('../../assets/images/logo/landscapelogo/landscape7.jpeg')}
                  alt=""
                  className={classes.image}
                />
              </Container>
            </Carousel.Slide>
          </div>
        </Carousel>
      </div>
      {/*-------------------------------------------- 
        CAROUSEL 3
      ---------------------------------------------*/}
      {/* <Carousel
        className={classes.carouselPartners3}
        withControls={false}
        height={110}
        //slideSize="33.333333%"
        slideSize="50%"
        slideGap="md"
        loop
        align="start"
        slidesToScroll={2}
        plugins={[autoplay.current]}
        onMouseEnter={autoplay.current.stop}
        onMouseLeave={autoplay.current.reset}
      >
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape1.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape2.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape3.png')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape4.png')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape5.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape6.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
        <Carousel.Slide>
          <Container className={classes.container3}>
            <img
              src={require('../../assets/images/logo/landscapelogo/landscape7.jpeg')}
              alt=""
              className={classes.image}
            />
          </Container>
        </Carousel.Slide>
      </Carousel> */}
    </div>
  );
};

export default PartnersCompo;
